/**
 * Ordered trainer stages. Environment and hands specialists advance these when
 * placement/mount criteria are met; foundation only owns the gating scaffold.
 *
 * This is a non-energized training mockup — no live electrical teaching.
 */
export const TRAINER_STEPS = [
  "place_wires",
  "mount_receptacle",
  "complete",
] as const;

export type TrainerStep = (typeof TRAINER_STEPS)[number];

export interface StepInfo {
  id: TrainerStep;
  /** Short HUD label. */
  label: string;
  /** One-line coaching copy for the current stage. */
  prompt: string;
}

export const STEP_INFO: Record<TrainerStep, StepInfo> = {
  place_wires: {
    id: "place_wires",
    label: "Place wires",
    prompt: "Grab each wire and seat it on its matching labeled terminal.",
  },
  mount_receptacle: {
    id: "mount_receptacle",
    label: "Mount receptacle",
    prompt: "Grab the receptacle and mount it into the electrical box.",
  },
  complete: {
    id: "complete",
    label: "Complete",
    prompt: "Training mockup complete. Press Reset to practice again.",
  },
};

export function stepIndex(step: TrainerStep): number {
  return TRAINER_STEPS.indexOf(step);
}

export function nextStep(step: TrainerStep): TrainerStep | null {
  const i = stepIndex(step);
  if (i < 0 || i >= TRAINER_STEPS.length - 1) return null;
  return TRAINER_STEPS[i + 1]!;
}
